import React from 'react';
import { AgPhase3FileMetadata, PledgeLevel } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import { GridContainer, GridContainerItem, pledgeLevelTranslations, utils } from 'shared';
import { PledgeCertificateRegisteredCompanySummary } from './PledgeCertificateRegisteredCompanySummary/PledgeCertificateRegisteredCompanySummary';

interface PledgeCertificateDocumentSummaryProps {
  phase3FileInfo: AgPhase3FileMetadata;
}

export const PledgeCertificateDocumentSummary: React.FunctionComponent<PledgeCertificateDocumentSummaryProps> = ({
  phase3FileInfo
}) => {
  const items: GridContainerItem[] = [
    {
      label: utils.text.toTitleCase(i18next.t('registrationNumber')),
      value: phase3FileInfo?.pledgeCertificateRegistrationNumber
    },
    {
      label: utils.text.toTitleCase(i18next.t('registrationDate')),
      value: phase3FileInfo?.pledgeCertificateRegistrationDate
        ? utils.date.formatDate(phase3FileInfo.pledgeCertificateRegistrationDate)
        : undefined
    },
    {
      label: utils.text.toTitleCase(i18next.t('pledgeLevel')),
      value: phase3FileInfo?.pledgeCertificateLevel
        ? pledgeLevelTranslations[phase3FileInfo.pledgeCertificateLevel]
        : undefined
    }
  ];

  return (
    <div>
      <GridContainer columns={3} items={items} />
      {!!phase3FileInfo.pledgeCertificateLevel &&
      [PledgeLevel.SECOND, PledgeLevel.THIRD].includes(phase3FileInfo.pledgeCertificateLevel) ? (
        <PledgeCertificateRegisteredCompanySummary
          title={i18next.t('firstCompanyRegistered')}
          companyInfo={phase3FileInfo.pledgeCertificateFirstCompanyRegistered}
        />
      ) : null}
      {!!phase3FileInfo.pledgeCertificateLevel && phase3FileInfo.pledgeCertificateLevel === PledgeLevel.THIRD ? (
        <PledgeCertificateRegisteredCompanySummary
          title={i18next.t('secondCompanyRegistered')}
          companyInfo={phase3FileInfo.pledgeCertificateSecondCompanyRegistered}
        />
      ) : null}
    </div>
  );
};
